import { IDevice } from '@/models/device';
import { IFamocoConfig, IFamocoConfigResponse, IFamocoFleet, IFamocoOrg, IFamocoSyncAllResult, IFamocoSyncResult } from '@/models/famoco';
import axios from 'axios';

import { Resolve } from './';
import config from './config';

const url = process.env.VUE_APP_SERVER_PATH;

export const getFamocoConfig = () =>
  new Promise((resolve: Resolve<IFamocoConfigResponse>, reject) => {
    axios
      .get(`${url}/admin/famoco-config`, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const createFamocoConfig = (payload: { api_token: string; org_id: number; base_url: string }) =>
  new Promise((resolve: Resolve<IFamocoConfig>, reject) => {
    axios
      .post(`${url}/admin/famoco-config`, payload, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const updateFamocoConfig = (id: number, payload: { api_token?: string; org_id?: number; base_url?: string }) =>
  new Promise((resolve: Resolve<IFamocoConfig>, reject) => {
    axios
      .patch(`${url}/admin/famoco-config/${id}`, payload, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const validateFamocoToken = (api_token: string) =>
  new Promise((resolve: Resolve<{ orgs: IFamocoOrg[] }>, reject) => {
    axios
      .post(`${url}/admin/famoco-config/validate-token`, { api_token }, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const syncFamocoAll = () =>
  new Promise((resolve: Resolve<IFamocoSyncAllResult>, reject) => {
    axios
      .post(`${url}/admin/famoco-config/sync-all`, {}, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const syncFamocoFleets = () =>
  new Promise((resolve: Resolve<IFamocoFleet[]>, reject) => {
    axios
      .post(`${url}/admin/famoco-config/sync`, {}, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const syncFamocoDevice = (deviceId: number) =>
  new Promise((resolve: Resolve<IDevice>, reject) => {
    axios
      .post(`${url}/admin/devices/${deviceId}/famoco/sync`, {}, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const syncAllFamocoDevices = () =>
  new Promise((resolve: Resolve<IFamocoSyncResult>, reject) => {
    axios
      .post(`${url}/admin/devices/famoco/sync_all`, {}, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });

export const setFamocoDeviceFleet = (deviceId: number, fleetId: number | null) =>
  new Promise((resolve: Resolve<IDevice>, reject) => {
    axios
      .post(`${url}/admin/devices/${deviceId}/famoco/set_fleet`, { fleet_id: fleetId }, config())
      .then(response => resolve(response))
      .catch(err => reject(err));
  });
